// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


const envObject = {
  // serviceUrl : 'http://192.168.1.102:1003/api/v1', //local
  serviceUrl : 'http://ssuhs-uat.universus.co.in:5003/api/v1', 
  //  serviceUrl : 'http://192.168.1.32:5003/api/v1', //local
  //  serviceUrl : 'https://ssuhs.universus.co.in:1004/api/v1', //Production 
    secretkey  :  ""
};

const razorpayKeyId = 'rzp_test_CGhEdzaJYtYTP6' // sshu uat key
// const razorpayKeyId = 'rzp_live_Xj9x6BNMVtJelq' // sshu live key

export const environment = {
  production: false,
  serviceUrl: envObject.serviceUrl,
  razorpayKeyId: razorpayKeyId
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

